export enum D0Types {
  positive = 'positive',
  negative = 'negative',
}
